import {Component, OnDestroy, OnInit} from '@angular/core';
import { StateService } from '@core/services/state.service';
import { TeamService } from '@core/services/team.service';
import {IStadium} from '@shared/models/stadium';
import {ConsentService} from '@utils/services/shared-consent/consent.service';
import {Subscription} from 'rxjs';
import {LAZY_SCRIPT_NAME, LazyScriptLoaderService, LazyScriptStore} from '@utils/services/lazy-script-loader/lazy-script-loader.service';

declare const google: any;

@Component({
  selector: 'team-info-stadion',
  templateUrl: './team-info-stadion.component.html',
  styleUrls: ['./team-info-stadion.component.scss'],
})


export class TeamInfoStadionComponent implements OnInit, OnDestroy {

  resultsFound = false;
  address = '';
  stadion: IStadium;
  private map;
  private consent$: Subscription;

  constructor( private appStateService: StateService,
               private teamService: TeamService,
               private consentService: ConsentService,
               private lazyScriptLoader: LazyScriptLoaderService ) {}

  ngOnInit() {
    this.stadion = this.teamService.getCurrentTeam().stadium;
    this.resolveAddress();
  }

  public ngOnDestroy() {
    if (this.consent$) {
      this.consent$.unsubscribe();
    }
  }

  resolveAddress() {
    if (!StateService.isBrowser) {
      return;
    }

    this.consent$ = this.consentService.consentChange.subscribe(() => {
      this.init();
    })
  }

  private async init(): Promise<void> {
    if (!this.consentService.hasAccepted()) {
      console.warn('[Team Info] Could not load google maps - no consent!');
      return;
    }
    await this.lazyScriptLoader.load(LAZY_SCRIPT_NAME.GOOGLE_MAPS);
    const gc = new google.maps.Geocoder();
    if (this.stadion != null) {
      gc.geocode({ 'address': this.stadion.address }, this.initMap.bind(this));
    }
  }

  initMap(results, status) {
    if (!StateService.isBrowser) {
      return;
    }
    if (results.length === 0) {
      return;
    }

    this.resultsFound = true;
    this.address = results[0].formatted_address;
    const mapProp = {
      center: results[0].geometry.location,
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };

    if (!StateService.isBrowser) {
      return;
    }

    this.map = new google.maps.Map(document.getElementById('google-map'), mapProp);

    const marker = new google.maps.Marker({
      map: this.map,
      position: results[0].geometry.location
    });
  }
}
